export default __webpack_public_path__ + "cd31d3f.png";